import { useEffect, useState } from 'react';

import { DirectorPayload } from '../services/directorService';
import { fetchDirector } from '../services/directorService';

export const useDirector = () => {
  const [director, setDirector] = useState<DirectorPayload | null>(null);

  useEffect(() => {
    let isMounted = true;

    const loadDirector = async () => {
      try {
        const directorData = await fetchDirector();
        if (isMounted) {
          setDirector(directorData);
        }
      } catch (error) {
        console.error('Failed to load director content', error);
      }
    };

    loadDirector();

    return () => {
      isMounted = false;
    };
  }, []);

  return { director };
};
